import { render, staticRenderFns } from "./ULAProfile.vue?vue&type=template&id=5d9d1496"
import script from "./ULAProfile.vue?vue&type=script&lang=js"
export * from "./ULAProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports